<template>
  <search-custom-dropdown
    v-model="searchInput.petBtn.state"
    :search-input-text="searchInput.petBtn.text"
    :is-filled="lastNewQuery.query.Pets === true ? true : false"
    :width="50"
  >
    <template v-slot:drop-content>
      <checkbox-list-selector
        :checkbox-options="searchOptions.petOptions"
        :pre-selected="selectedPetOptions"
        @update-selection="
          updateCheckboxSelections($event, 'petBtn', 'Pets Not Allowed')"
      />
    </template>
  </search-custom-dropdown>
</template>

<script>
import searchLayoutHandler from '../../mixins/searchLayoutHandler'

export default {
  mixins: [searchLayoutHandler]
}
</script>
